import {
	LOAD_CLUB,
	LOAD_CLUB_WEATHER,
	LOAD_CLUB_FAIL,
	FAVORITE_CLUB,
	UNFAVORITE_CLUB,
	REQUEST_CLUB_MEMBERSHIP,
	CANCEL_CLUB_MEMBERSHIP,
} from "../actions";
import { Club, Weather, SlotsData } from "../types";

export type ClubState = {
	club: Club;
	weather: Weather;
	loading: boolean;
};
export const initialState = {
	club: null as null | Club,
	weather: null as null | Weather,
	loading: true as boolean,
};

export default function (state: ClubState = initialState, action) {
	switch (action.type) {
		case LOAD_CLUB: {
			const club = action.club;
			return { ...initialState, club, loading: false };
		}

		case UNFAVORITE_CLUB: {
			let club = state.club;
			club.clubDetails.isFavorite = false;

			return { ...state, club: { ...club } };
		}

		case LOAD_CLUB_FAIL: {
			return { ...state, loading: false };
		}

		case LOAD_CLUB_WEATHER: {
			const weather = action.weather;
			return { ...state, weather };
		}

		case REQUEST_CLUB_MEMBERSHIP: {
			let club = state.club;
			if (club) {
				club.clubDetails.memberStatus = "request_pending";

				return { ...state, club: { ...club } };
			}

			return state;
		}

		case CANCEL_CLUB_MEMBERSHIP: {
			let club = state.club;
			if (club) {
				club.clubDetails.memberStatus = "not_member";

				return { ...state, club: { ...club } };
			}

			return state;
		}

		default:
			return state;
	}
}
